


































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import ajax from "@/lib/ajax";
import { AppModule } from "@/store/modules/app";
import WorkerProfileDto from "@/models/Workers/WorkerProfileDto";
import BookingRoleWorkerShiftStatus from "@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus";

@Component({
  name: "WorkerUserSimulateApp",
})
export default class extends GiganautVueDialog {

  workerProfile = '';
  bookedShifts = '';
  offeredShifts = '';
  appliedShifts = '';
  rejectedShifts = '';
  copiedWorkerProfile = false;
  copiedBookedShifts = false;
  copiedOfferedShifts = false;
  copiedAppliedShifts = false;
  copiedRejectedShifts = false;  

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      await ajax.get(`/api/v1/agency/workers/${WorkerDetailsModule.currentWorker.id}/app-profile`)
      .then(response => {
        this.workerProfile = response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
      })
      const bookedRequest = {
        "statuses":[BookingRoleWorkerShiftStatus.BookedConfirmed, BookingRoleWorkerShiftStatus.BookedUnconfirmed]
      } 
      await ajax.post(`/api/v1/agency/workers/${WorkerDetailsModule.currentWorker.id}/app-shifts`, bookedRequest)
      .then(response => {
        this.bookedShifts = response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
      })
      const offeredRequest = {
        "statuses":[BookingRoleWorkerShiftStatus.Offered]
      } 
      await ajax.post(`/api/v1/agency/workers/${WorkerDetailsModule.currentWorker.id}/app-shifts`, offeredRequest)
      .then(response => {
        this.offeredShifts = response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
      })
      const appliedRequest = {
        "statuses":[BookingRoleWorkerShiftStatus.Applied]
      } 
      await ajax.post(`/api/v1/agency/workers/${WorkerDetailsModule.currentWorker.id}/app-shifts`, appliedRequest)
      .then(response => {
        this.appliedShifts = response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
      })
      const rejectedRequest = {
        "statuses":[BookingRoleWorkerShiftStatus.Rejected]
      } 
      await ajax.post(`/api/v1/agency/workers/${WorkerDetailsModule.currentWorker.id}/app-shifts`, rejectedRequest)
      .then(response => {
        this.rejectedShifts = response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
      })
    }
  }

  async copyWorkerProfile() {
    try {
      await navigator.clipboard.writeText(JSON.stringify(this.workerProfile));
      this.copiedWorkerProfile = true;
    } catch (err) {
      this.copiedWorkerProfile = false;
    }
  }

  async copyBookedShifts() {
    try {
      await navigator.clipboard.writeText(JSON.stringify(this.bookedShifts));
      this.copiedBookedShifts = true;
    } catch (err) {
      this.copiedBookedShifts = false;
    }
  }

  async copyOfferedShifts() {
    try {
      await navigator.clipboard.writeText(JSON.stringify(this.offeredShifts));
      this.copiedOfferedShifts = true;
    } catch (err) {
      this.copiedOfferedShifts = false;
    }
  }

  async copyAppliedShifts() {
    try {
      await navigator.clipboard.writeText(JSON.stringify(this.appliedShifts));
      this.copiedAppliedShifts = true;
    } catch (err) {
      this.copiedAppliedShifts = false;
    }
  }

  async copyRejectedShifts() {
    try {
      await navigator.clipboard.writeText(JSON.stringify(this.rejectedShifts));
      this.copiedRejectedShifts = true;
    } catch (err) {
      this.copiedRejectedShifts = false;
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

}
